export default "__VITE_ASSET__13fb4347__"